"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saskatchewanCities = void 0;
exports.saskatchewanCities = [
    {
        label: "Abbey",
        value: 5802,
    },
    {
        label: "Aberdeen",
        value: 5804,
    },
    {
        label: "Abernethy",
        value: 5806,
    },
    {
        label: "Adanac",
        value: 5808,
    },
    {
        label: "Admiral",
        value: 5810,
    },
    {
        label: "Alameda",
        value: 5812,
    },
    {
        label: "Alida",
        value: 5814,
    },
    {
        label: "Allan",
        value: 5816,
    },
    {
        label: "Alsask",
        value: 5818,
    },
    {
        label: "Alvena",
        value: 5820,
    },
    {
        label: "Aneroid",
        value: 5822,
    },
    {
        label: "Annaheim",
        value: 5803,
    },
    {
        label: "Antler",
        value: 5824,
    },
    {
        label: "Arborfield",
        value: 5826,
    },
    {
        label: "Archerwill",
        value: 5828,
    },
    {
        label: "Arcola",
        value: 5830,
    },
    {
        label: "Ardath",
        value: 5832,
    },
    {
        label: "Ardili",
        value: 5834,
    },
    {
        label: "Arelee",
        value: 5836,
    },
    {
        label: "Arran",
        value: 5838,
    },
    {
        label: "Asquith",
        value: 5840,
    },
    {
        label: "Assiniboia",
        value: 5842,
    },
    {
        label: "Atwater",
        value: 5844,
    },
    {
        label: "Avonlea",
        value: 5846,
    },
    {
        label: "Aylesbury",
        value: 5848,
    },
    {
        label: "Aylsham",
        value: 5850,
    },
    {
        label: "Balcarres",
        value: 5862,
    },
    {
        label: "Balgonie",
        value: 5864,
    },
    {
        label: "Bangor",
        value: 5866,
    },
    {
        label: "Battleford",
        value: 5868,
    },
    {
        label: "Beatty",
        value: 5870,
    },
    {
        label: "Beauval",
        value: 5805,
    },
    {
        label: "Beechy",
        value: 5872,
    },
    {
        label: "Belle Plaine",
        value: 5874,
    },
    {
        label: "Bellegarde",
        value: 5807,
    },
    {
        label: "Bengough",
        value: 5876,
    },
    {
        label: "Benson",
        value: 5878,
    },
    {
        label: "Bethume",
        value: 5880,
    },
    {
        label: "Bienfait",
        value: 5882,
    },
    {
        label: "Big Beaver",
        value: 5883,
    },
    {
        label: "Big River",
        value: 5884,
    },
    {
        label: "Biggar",
        value: 5809,
    },
    {
        label: "Bigger",
        value: 5886,
    },
    {
        label: "Birch Hills",
        value: 5888,
    },
    {
        label: "Birsay",
        value: 5890,
    },
    {
        label: "Bjorkdale",
        value: 5892,
    },
    {
        label: "Bladworth",
        value: 5894,
    },
    {
        label: "Blaine Lake",
        value: 5896,
    },
    {
        label: "Borden, SK",
        value: 5898,
    },
    {
        label: "Bounty",
        value: 5900,
    },
    {
        label: "Bracken",
        value: 5902,
    },
    {
        label: "Bradwell",
        value: 5904,
    },
    {
        label: "Bredenbury",
        value: 5811,
    },
    {
        label: "Briercrest",
        value: 5908,
    },
    {
        label: "Broadview",
        value: 5910,
    },
    {
        label: "Brock",
        value: 5912,
    },
    {
        label: "Broderick",
        value: 5914,
    },
    {
        label: "Brownlee",
        value: 5916,
    },
    {
        label: "Bruno",
        value: 5918,
    },
    {
        label: "B-Say-Tah",
        value: 5860,
    },
    {
        label: "Buchanan",
        value: 5920,
    },
    {
        label: "Buena Vista",
        value: 5922,
    },
    {
        label: "Buffalo Narrows",
        value: 5923,
    },
    {
        label: "Bulyea",
        value: 5924,
    },
    {
        label: "Burstall",
        value: 5926,
    },
    {
        label: "Bushell Park",
        value: 5927,
    },
    {
        label: "Cabri",
        value: 5930,
    },
    {
        label: "Cadillac, SK",
        value: 5932,
    },
    {
        label: "Calder",
        value: 5934,
    },
    {
        label: "Cando",
        value: 5936,
    },
    {
        label: "Canora",
        value: 5938,
    },
    {
        label: "Canwood",
        value: 5940,
    },
    {
        label: "Carievale",
        value: 5942,
    },
    {
        label: "Carlyle",
        value: 5944,
    },
    {
        label: "Carlyle Lake Reso",
        value: 5946,
    },
    {
        label: "Carmichael",
        value: 5948,
    },
    {
        label: "Carnduff",
        value: 5950,
    },
    {
        label: "Caronport",
        value: 5951,
    },
    {
        label: "Carragana",
        value: 5952,
    },
    {
        label: "Carrot River",
        value: 5954,
    },
    {
        label: "Central Butte",
        value: 5956,
    },
    {
        label: "Ceylon",
        value: 5958,
    },
    {
        label: "Chamberlain",
        value: 5960,
    },
    {
        label: "Chaplin",
        value: 5962,
    },
    {
        label: "Choiceland",
        value: 5964,
    },
    {
        label: "Christopher Lake",
        value: 5963,
    },
    {
        label: "Churchbridge",
        value: 5966,
    },
    {
        label: "Clavet",
        value: 5817,
    },
    {
        label: "Climax",
        value: 5968,
    },
    {
        label: "Coderre",
        value: 5970,
    },
    {
        label: "Codette",
        value: 5972,
    },
    {
        label: "Coleville",
        value: 5974,
    },
    {
        label: "Colgate",
        value: 5976,
    },
    {
        label: "Colonsay",
        value: 5978,
    },
    {
        label: "Conquest",
        value: 5980,
    },
    {
        label: "Consul",
        value: 5982,
    },
    {
        label: "Corning",
        value: 5813,
    },
    {
        label: "Coronach",
        value: 5984,
    },
    {
        label: "Craik",
        value: 5986,
    },
    {
        label: "Craven",
        value: 5988,
    },
    {
        label: "Creelman",
        value: 5990,
    },
    {
        label: "Creighton",
        value: 5992,
    },
    {
        label: "Cudworth",
        value: 5994,
    },
    {
        label: "Cumberland House",
        value: 5995,
    },
    {
        label: "Cupar",
        value: 5996,
    },
    {
        label: "Cut Knife",
        value: 5998,
    },
    {
        label: "Dafoe",
        value: 6002,
    },
    {
        label: "Dalmeny",
        value: 6004,
    },
    {
        label: "Davidson",
        value: 6006,
    },
    {
        label: "Debden",
        value: 6008,
    },
    {
        label: "Delisle",
        value: 6010,
    },
    {
        label: "Denare Beach",
        value: 6011,
    },
    {
        label: "Denholm",
        value: 6012,
    },
    {
        label: "Denzil",
        value: 6014,
    },
    {
        label: "Dilke",
        value: 6016,
    },
    {
        label: "Dinsmore",
        value: 6018,
    },
    {
        label: "Disley",
        value: 6020,
    },
    {
        label: "Dodsland",
        value: 6022,
    },
    {
        label: "Dollard",
        value: 6024,
    },
    {
        label: "Domremy",
        value: 6026,
    },
    {
        label: "Drake",
        value: 6028,
    },
    {
        label: "Drinkwater",
        value: 6030,
    },
    {
        label: "Dubuc",
        value: 6032,
    },
    {
        label: "Duck Lake",
        value: 6034,
    },
    {
        label: "Duff",
        value: 6036,
    },
    {
        label: "Dunblane",
        value: 6038,
    },
    {
        label: "Dundurn",
        value: 6040,
    },
    {
        label: "Duval",
        value: 6042,
    },
    {
        label: "Dysart",
        value: 6044,
    },
    {
        label: "Earl Grey",
        value: 6050,
    },
    {
        label: "Eastend",
        value: 6052,
    },
    {
        label: "Eatonia",
        value: 6054,
    },
    {
        label: "Ebebezer",
        value: 6056,
    },
    {
        label: "Edam",
        value: 6058,
    },
    {
        label: "Edenwold",
        value: 6060,
    },
    {
        label: "Elbow",
        value: 6062,
    },
    {
        label: "Elfros",
        value: 6064,
    },
    {
        label: "Elrose",
        value: 6066,
    },
    {
        label: "Elstow",
        value: 6068,
    },
    {
        label: "Emerald Park",
        value: 6736,
    },
    {
        label: "Endeavour",
        value: 6070,
    },
    {
        label: "Englefeld",
        value: 6072,
    },
    {
        label: "Ernfold",
        value: 6074,
    },
    {
        label: "Esterhazy",
        value: 6076,
    },
    {
        label: "Estevan",
        value: 6078,
    },
    {
        label: "Eston",
        value: 6080,
    },
    {
        label: "Etters Beach",
        value: 6082,
    },
    {
        label: "Evesham",
        value: 6084,
    },
    {
        label: "Eyebrow",
        value: 6086,
    },
    {
        label: "Fairlight",
        value: 6090,
    },
    {
        label: "Fenwood",
        value: 6092,
    },
    {
        label: "Ferland",
        value: 6094,
    },
    {
        label: "Fielding",
        value: 6096,
    },
    {
        label: "Fife Lake",
        value: 6098,
    },
    {
        label: "Fillmore",
        value: 6100,
    },
    {
        label: "Findlater",
        value: 6102,
    },
    {
        label: "Fiske",
        value: 6103,
    },
    {
        label: "Flaxcombe",
        value: 6104,
    },
    {
        label: "Fleming",
        value: 6106,
    },
    {
        label: "Foam Lake",
        value: 6110,
    },
    {
        label: "Forget",
        value: 6112,
    },
    {
        label: "Fort Qu'appelle",
        value: 6114,
    },
    {
        label: "Fosston",
        value: 6116,
    },
    {
        label: "Fox Valley",
        value: 6118,
    },
    {
        label: "Francis",
        value: 6120,
    },
    {
        label: "Frobisher",
        value: 6122,
    },
    {
        label: "Frontier",
        value: 6124,
    },
    {
        label: "Gainsborough",
        value: 6130,
    },
    {
        label: "Gerald",
        value: 6132,
    },
    {
        label: "Girvin",
        value: 6134,
    },
    {
        label: "Gladmar",
        value: 6136,
    },
    {
        label: "Glaslyn",
        value: 6138,
    },
    {
        label: "Glen Ewen",
        value: 6140,
    },
    {
        label: "Glenavon",
        value: 6142,
    },
    {
        label: "Glenside",
        value: 6144,
    },
    {
        label: "Glentworth",
        value: 6146,
    },
    {
        label: "Glidden",
        value: 6148,
    },
    {
        label: "Golden Prairie",
        value: 6150,
    },
    {
        label: "Goodeve",
        value: 6152,
    },
    {
        label: "Goodsoil",
        value: 6154,
    },
    {
        label: "Goodwater",
        value: 6156,
    },
    {
        label: "Govan",
        value: 6158,
    },
    {
        label: "Grandora",
        value: 5821,
    },
    {
        label: "Grandview Beach S",
        value: 6160,
    },
    {
        label: "Gravelbourg",
        value: 6162,
    },
    {
        label: "Grayson",
        value: 6164,
    },
    {
        label: "Grenfell",
        value: 6166,
    },
    {
        label: "Guernsey",
        value: 6168,
    },
    {
        label: "Gull Lake, SK",
        value: 6170,
    },
    {
        label: "Hafford",
        value: 6174,
    },
    {
        label: "Hague",
        value: 6176,
    },
    {
        label: "Halbrite",
        value: 6178,
    },
    {
        label: "Handel",
        value: 6180,
    },
    {
        label: "Hanley",
        value: 6182,
    },
    {
        label: "Hardy",
        value: 6184,
    },
    {
        label: "Harris",
        value: 6186,
    },
    {
        label: "Hawarden",
        value: 6188,
    },
    {
        label: "Hazelwood No.94",
        value: 5819,
    },
    {
        label: "Hazenmore",
        value: 6190,
    },
    {
        label: "Hazlet",
        value: 6192,
    },
    {
        label: "Hepburn",
        value: 6194,
    },
    {
        label: "Herbert",
        value: 6196,
    },
    {
        label: "Herschel",
        value: 6198,
    },
    {
        label: "Heward",
        value: 6200,
    },
    {
        label: "Hodgeville",
        value: 6202,
    },
    {
        label: "Hold Fast",
        value: 6204,
    },
    {
        label: "Horizon",
        value: 6206,
    },
    {
        label: "Hubbard",
        value: 6208,
    },
    {
        label: "Hudson Bay",
        value: 6210,
    },
    {
        label: "Humboldt",
        value: 6212,
    },
    {
        label: "Hyas",
        value: 6214,
    },
    {
        label: "Ãle-Ã -la-Crosse",
        value: 6218,
    },
    {
        label: "Imperial",
        value: 6220,
    },
    {
        label: "Indian Head",
        value: 6222,
    },
    {
        label: "Insinger",
        value: 6224,
    },
    {
        label: "Invermay",
        value: 6226,
    },
    {
        label: "Ituna",
        value: 6228,
    },
    {
        label: "Jansen",
        value: 6230,
    },
    {
        label: "Jasmin",
        value: 6232,
    },
    {
        label: "Jedburgh",
        value: 6234,
    },
    {
        label: "Kamsack",
        value: 6240,
    },
    {
        label: "Kannata Valley",
        value: 6242,
    },
    {
        label: "Katepwa Beach",
        value: 6244,
    },
    {
        label: "Keeler",
        value: 6246,
    },
    {
        label: "Kelfield",
        value: 6250,
    },
    {
        label: "Kelliher",
        value: 6252,
    },
    {
        label: "Kelvington",
        value: 6254,
    },
    {
        label: "Kenaston",
        value: 6256,
    },
    {
        label: "Kendal",
        value: 6258,
    },
    {
        label: "Kennedy",
        value: 6260,
    },
    {
        label: "Kerrobert",
        value: 6248,
    },
    {
        label: "Khedive",
        value: 6262,
    },
    {
        label: "Killaly",
        value: 6264,
    },
    {
        label: "Kincaid",
        value: 6266,
    },
    {
        label: "Kindersley",
        value: 6268,
    },
    {
        label: "Kinistino",
        value: 6270,
    },
    {
        label: "Kinley",
        value: 6272,
    },
    {
        label: "Kipabiskau",
        value: 6274,
    },
    {
        label: "Kipling",
        value: 6276,
    },
    {
        label: "Kisbey",
        value: 6278,
    },
    {
        label: "Krydor",
        value: 6280,
    },
    {
        label: "Kyle",
        value: 6282,
    },
    {
        label: "La Loche",
        value: 5825,
    },
    {
        label: "La Ronge",
        value: 6312,
    },
    {
        label: "Lafleche, SK",
        value: 6290,
    },
    {
        label: "Laird",
        value: 6292,
    },
    {
        label: "Lake Alma",
        value: 6294,
    },
    {
        label: "Lake Lenore",
        value: 6296,
    },
    {
        label: "Lampman",
        value: 6298,
    },
    {
        label: "Lancer",
        value: 6300,
    },
    {
        label: "Landis",
        value: 6302,
    },
    {
        label: "Lang",
        value: 6304,
    },
    {
        label: "Langenburg",
        value: 6306,
    },
    {
        label: "Langham",
        value: 6308,
    },
    {
        label: "Lanigan",
        value: 6310,
    },
    {
        label: "Lashburn",
        value: 6313,
    },
    {
        label: "Lawson",
        value: 6314,
    },
    {
        label: "Leader",
        value: 6316,
    },
    {
        label: "Leask",
        value: 6318,
    },
    {
        label: "Lebret",
        value: 6320,
    },
    {
        label: "Leipzig",
        value: 6322,
    },
    {
        label: "Lemberg",
        value: 6324,
    },
    {
        label: "Leney",
        value: 6326,
    },
    {
        label: "Leoville",
        value: 6328,
    },
    {
        label: "Leross",
        value: 6330,
    },
    {
        label: "Leroy",
        value: 6332,
    },
    {
        label: "Leslie",
        value: 6334,
    },
    {
        label: "Lestock",
        value: 6336,
    },
    {
        label: "Liberty",
        value: 6338,
    },
    {
        label: "Liebanthal",
        value: 6339,
    },
    {
        label: "Limerick",
        value: 6340,
    },
    {
        label: "Lintlaw",
        value: 6342,
    },
    {
        label: "Lipton",
        value: 6344,
    },
    {
        label: "Lloydminster, SK",
        value: 6345,
    },
    {
        label: "Lockwood",
        value: 6346,
    },
    {
        label: "Loon Lake",
        value: 6348,
    },
    {
        label: "Loreburn",
        value: 6350,
    },
    {
        label: "Love",
        value: 6352,
    },
    {
        label: "Loverna",
        value: 6354,
    },
    {
        label: "Lucky Lake",
        value: 6356,
    },
    {
        label: "Lumsden Beac, SK",
        value: 6360,
    },
    {
        label: "Lumsden, SK",
        value: 6358,
    },
    {
        label: "Luseland",
        value: 6362,
    },
    {
        label: "MacDowall",
        value: 5827,
    },
    {
        label: "Macklin",
        value: 6368,
    },
    {
        label: "MacNutt",
        value: 6370,
    },
    {
        label: "Macoun",
        value: 6372,
    },
    {
        label: "Macrorie",
        value: 6374,
    },
    {
        label: "Madison",
        value: 6376,
    },
    {
        label: "Maidstone",
        value: 6377,
    },
    {
        label: "Main Centre",
        value: 6381,
    },
    {
        label: "Major",
        value: 6378,
    },
    {
        label: "Makwa",
        value: 6380,
    },
    {
        label: "Manitou Beach",
        value: 6382,
    },
    {
        label: "Mankota",
        value: 6384,
    },
    {
        label: "Manor",
        value: 6386,
    },
    {
        label: "Mantario",
        value: 6388,
    },
    {
        label: "Maple Creek",
        value: 6390,
    },
    {
        label: "Marcelin",
        value: 6392,
    },
    {
        label: "Marengo",
        value: 6394,
    },
    {
        label: "Margo",
        value: 6396,
    },
    {
        label: "Markinch",
        value: 6398,
    },
    {
        label: "Marquis",
        value: 6400,
    },
    {
        label: "Marshall",
        value: 6401,
    },
    {
        label: "Martensville",
        value: 6402,
    },
    {
        label: "Maryfield",
        value: 6404,
    },
    {
        label: "Maymont",
        value: 6406,
    },
    {
        label: "Mazenod",
        value: 6408,
    },
    {
        label: "McLean",
        value: 6410,
    },
    {
        label: "McMahon",
        value: 6411,
    },
    {
        label: "McTaggart",
        value: 6412,
    },
    {
        label: "Meacham",
        value: 6414,
    },
    {
        label: "Meadow Lake",
        value: 6416,
    },
    {
        label: "Meath Park",
        value: 6418,
    },
    {
        label: "Medstead",
        value: 6420,
    },
    {
        label: "Melfort",
        value: 6422,
    },
    {
        label: "Melville",
        value: 6424,
    },
    {
        label: "Mendham",
        value: 6426,
    },
    {
        label: "Meota",
        value: 6428,
    },
    {
        label: "Mervin",
        value: 6430,
    },
    {
        label: "Metinota",
        value: 6432,
    },
    {
        label: "Meyronne",
        value: 6434,
    },
    {
        label: "Midale",
        value: 6436,
    },
    {
        label: "Middle Lake",
        value: 6438,
    },
    {
        label: "Milden",
        value: 6440,
    },
    {
        label: "Milestone",
        value: 6442,
    },
    {
        label: "Minton",
        value: 6444,
    },
    {
        label: "Mistatim",
        value: 6446,
    },
    {
        label: "Monchy",
        value: 6447,
    },
    {
        label: "Montmartre",
        value: 6448,
    },
    {
        label: "Moose Jaw",
        value: 6450,
    },
    {
        label: "Moosomin",
        value: 6454,
    },
    {
        label: "Morse",
        value: 6456,
    },
    {
        label: "Mortlach",
        value: 6458,
    },
    {
        label: "Mossbank",
        value: 6460,
    },
    {
        label: "Muenster",
        value: 6462,
    },
    {
        label: "Naicam",
        value: 6468,
    },
    {
        label: "Neilburg, SK",
        value: 6469,
    },
    {
        label: "Netherhill",
        value: 6470,
    },
    {
        label: "Neudorf",
        value: 6472,
    },
    {
        label: "Neville",
        value: 6474,
    },
    {
        label: "Nipawin",
        value: 6476,
    },
    {
        label: "Nokomis",
        value: 6478,
    },
    {
        label: "Norquay",
        value: 6480,
    },
    {
        label: "North Battleford",
        value: 6482,
    },
    {
        label: "North Portal",
        value: 6484,
    },
    {
        label: "Northgate",
        value: 6483,
    },
    {
        label: "Odessa",
        value: 6488,
    },
    {
        label: "Ogema",
        value: 6490,
    },
    {
        label: "Osage",
        value: 6492,
    },
    {
        label: "Osler",
        value: 6494,
    },
    {
        label: "Other",
        value: 6999,
    },
    {
        label: "Oungre",
        value: 6495,
    },
    {
        label: "Outlook",
        value: 6496,
    },
    {
        label: "Oxbow",
        value: 6498,
    },
    {
        label: "Paddockwood",
        value: 6502,
    },
    {
        label: "Palmer",
        value: 6504,
    },
    {
        label: "Pangman",
        value: 6506,
    },
    {
        label: "Paradise Hill",
        value: 6509,
    },
    {
        label: "Parkside",
        value: 6508,
    },
    {
        label: "Paynton",
        value: 6510,
    },
    {
        label: "Peebles",
        value: 5829,
    },
    {
        label: "Pelly",
        value: 6512,
    },
    {
        label: "Pennant",
        value: 6514,
    },
    {
        label: "Pense",
        value: 6516,
    },
    {
        label: "Penzance",
        value: 6518,
    },
    {
        label: "Perdue",
        value: 6520,
    },
    {
        label: "Piapot",
        value: 6522,
    },
    {
        label: "Pilger",
        value: 6524,
    },
    {
        label: "Pilot Butte",
        value: 6526,
    },
    {
        label: "Plato",
        value: 6528,
    },
    {
        label: "Plenty",
        value: 6530,
    },
    {
        label: "Plunkett",
        value: 6532,
    },
    {
        label: "Ponteix",
        value: 6534,
    },
    {
        label: "Porcupine Plain",
        value: 6536,
    },
    {
        label: "Portreeve",
        value: 6538,
    },
    {
        label: "Preeceville",
        value: 6540,
    },
    {
        label: "Prelate",
        value: 6542,
    },
    {
        label: "Primate",
        value: 6544,
    },
    {
        label: "Prince Albert",
        value: 6546,
    },
    {
        label: "Prud'Homme",
        value: 6548,
    },
    {
        label: "Punnichy",
        value: 6550,
    },
    {
        label: "Qu'Appelle",
        value: 6552,
    },
    {
        label: "Quill Lake",
        value: 6554,
    },
    {
        label: "Quinton",
        value: 6556,
    },
    {
        label: "Rabbit Lake",
        value: 6560,
    },
    {
        label: "Radisson, SK",
        value: 6562,
    },
    {
        label: "Radville",
        value: 6564,
    },
    {
        label: "Rama",
        value: 6566,
    },
    {
        label: "Raymore",
        value: 6568,
    },
    {
        label: "Redvers",
        value: 6570,
    },
    {
        label: "Regina",
        value: 6572,
    },
    {
        label: "Regina Beach",
        value: 6574,
    },
    {
        label: "Regway",
        value: 6475,
    },
    {
        label: "Rhein",
        value: 6576,
    },
    {
        label: "Richard",
        value: 6578,
    },
    {
        label: "Richardson",
        value: 5815,
    },
    {
        label: "Richmond, SK",
        value: 6580,
    },
    {
        label: "Ridgedale",
        value: 6582,
    },
    {
        label: "Riverhurst",
        value: 6584,
    },
    {
        label: "Robsart",
        value: 6586,
    },
    {
        label: "Rocanville",
        value: 6588,
    },
    {
        label: "Roche Percee",
        value: 6590,
    },
    {
        label: "Rock Haven",
        value: 6592,
    },
    {
        label: "Rockglen",
        value: 6594,
    },
    {
        label: "Rose Valley",
        value: 6596,
    },
    {
        label: "Rosetown",
        value: 6598,
    },
    {
        label: "Rosthern",
        value: 6600,
    },
    {
        label: "Rouleau",
        value: 6602,
    },
    {
        label: "Ruddell",
        value: 6604,
    },
    {
        label: "Rush Lake",
        value: 6606,
    },
    {
        label: "Ruthilda",
        value: 6608,
    },
    {
        label: "Saint-Benedict",
        value: 6674,
    },
    {
        label: "Saint-Brieux",
        value: 6676,
    },
    {
        label: "Saint-Gregor",
        value: 6678,
    },
    {
        label: "Saint-Louis",
        value: 6680,
    },
    {
        label: "Saint-Victor",
        value: 6682,
    },
    {
        label: "Saint-Walburg",
        value: 7602,
    },
    {
        label: "Saltcoats",
        value: 6612,
    },
    {
        label: "Salvador",
        value: 6614,
    },
    {
        label: "Sandy Beach, SK",
        value: 6616,
    },
    {
        label: "Saskatchewan Beac",
        value: 6618,
    },
    {
        label: "Saskatoon",
        value: 6620,
    },
    {
        label: "Sceptre",
        value: 6622,
    },
    {
        label: "Scobey",
        value: 6623,
    },
    {
        label: "Scott",
        value: 6624,
    },
    {
        label: "Sedley",
        value: 6626,
    },
    {
        label: "Semans",
        value: 6628,
    },
    {
        label: "Senlac",
        value: 6630,
    },
    {
        label: "Shackleton",
        value: 6632,
    },
    {
        label: "Shamrock",
        value: 6634,
    },
    {
        label: "Shaunavon",
        value: 6636,
    },
    {
        label: "Shedo",
        value: 6638,
    },
    {
        label: "Shell Lake",
        value: 6640,
    },
    {
        label: "Shellbrook",
        value: 6642,
    },
    {
        label: "Silton",
        value: 6644,
    },
    {
        label: "Simmie",
        value: 6645,
    },
    {
        label: "Simpson",
        value: 6646,
    },
    {
        label: "Sintaluta",
        value: 6648,
    },
    {
        label: "Smeaton",
        value: 6650,
    },
    {
        label: "Smiley",
        value: 6652,
    },
    {
        label: "Southey",
        value: 6654,
    },
    {
        label: "Sovereign",
        value: 6656,
    },
    {
        label: "Spalding",
        value: 6658,
    },
    {
        label: "Speers",
        value: 6660,
    },
    {
        label: "Spirit Wood",
        value: 6662,
    },
    {
        label: "Spring Valley",
        value: 6666,
    },
    {
        label: "Spring Water",
        value: 6664,
    },
    {
        label: "Springside",
        value: 6668,
    },
    {
        label: "Spruce Lake",
        value: 6670,
    },
    {
        label: "Spy Hill",
        value: 6672,
    },
    {
        label: "Star City",
        value: 6684,
    },
    {
        label: "Steelman",
        value: 6685,
    },
    {
        label: "Stenen",
        value: 6686,
    },
    {
        label: "Stewart Valley",
        value: 6688,
    },
    {
        label: "Stockholm",
        value: 6690,
    },
    {
        label: "Stornoway",
        value: 6692,
    },
    {
        label: "Storthoaks",
        value: 6694,
    },
    {
        label: "Stoughton",
        value: 6696,
    },
    {
        label: "Stranraer",
        value: 6698,
    },
    {
        label: "Strasbourg",
        value: 6700,
    },
    {
        label: "Strongfield",
        value: 6702,
    },
    {
        label: "Sturgis",
        value: 6704,
    },
    {
        label: "Success",
        value: 6706,
    },
    {
        label: "Summerberry",
        value: 6708,
    },
    {
        label: "Swift Current",
        value: 6710,
    },
    {
        label: "Tantallon, SK",
        value: 6712,
    },
    {
        label: "Tessier",
        value: 6714,
    },
    {
        label: "Theodore",
        value: 6716,
    },
    {
        label: "Tisdale",
        value: 6718,
    },
    {
        label: "Togo",
        value: 6720,
    },
    {
        label: "Tompkins",
        value: 6722,
    },
    {
        label: "Torquay",
        value: 6724,
    },
    {
        label: "Tramping Lake",
        value: 6726,
    },
    {
        label: "Tribune",
        value: 6728,
    },
    {
        label: "Tugaske",
        value: 6730,
    },
    {
        label: "Turtleford",
        value: 6732,
    },
    {
        label: "Tuxford",
        value: 6734,
    },
    {
        label: "Unity",
        value: 6740,
    },
    {
        label: "Unwin",
        value: 6741,
    },
    {
        label: "Uranium City",
        value: 6742,
    },
    {
        label: "Usherville",
        value: 6743,
    },
    {
        label: "Val Marie",
        value: 6744,
    },
    {
        label: "Valparaiso",
        value: 6746,
    },
    {
        label: "Vanguard",
        value: 6748,
    },
    {
        label: "Vanscoy",
        value: 6750,
    },
    {
        label: "Vawn",
        value: 6752,
    },
    {
        label: "Veregin",
        value: 6754,
    },
    {
        label: "Vibank",
        value: 6756,
    },
    {
        label: "Viceroy",
        value: 6758,
    },
    {
        label: "Viscount",
        value: 6760,
    },
    {
        label: "Vonda",
        value: 6762,
    },
    {
        label: "Wadena",
        value: 6770,
    },
    {
        label: "Wakaw",
        value: 6772,
    },
    {
        label: "Wakaw Lake",
        value: 6774,
    },
    {
        label: "Waldeck",
        value: 6776,
    },
    {
        label: "Waldeim",
        value: 6778,
    },
    {
        label: "Waldron",
        value: 6780,
    },
    {
        label: "Wapella",
        value: 6782,
    },
    {
        label: "Warman",
        value: 6784,
    },
    {
        label: "Watrous",
        value: 6786,
    },
    {
        label: "Watson",
        value: 6788,
    },
    {
        label: "Wawota",
        value: 6790,
    },
    {
        label: "Webb",
        value: 6792,
    },
    {
        label: "Weekes",
        value: 6794,
    },
    {
        label: "Weirdale",
        value: 6796,
    },
    {
        label: "Weldon",
        value: 6798,
    },
    {
        label: "Welwyn",
        value: 6800,
    },
    {
        label: "West Bend",
        value: 6802,
    },
    {
        label: "West Poplar River",
        value: 6803,
    },
    {
        label: "Weyburn",
        value: 6804,
    },
    {
        label: "White City",
        value: 6806,
    },
    {
        label: "White Fox",
        value: 6808,
    },
    {
        label: "Whitewood",
        value: 6810,
    },
    {
        label: "Wilcox",
        value: 6812,
    },
    {
        label: "Wilkie",
        value: 6814,
    },
    {
        label: "Willow Bunch",
        value: 6816,
    },
    {
        label: "Willow Creek",
        value: 6819,
    },
    {
        label: "Willowbrook",
        value: 6818,
    },
    {
        label: "Windthorst",
        value: 6820,
    },
    {
        label: "Wiseton",
        value: 6822,
    },
    {
        label: "Wishart",
        value: 6824,
    },
    {
        label: "Wolseley",
        value: 6826,
    },
    {
        label: "Wood Mountain",
        value: 6828,
    },
    {
        label: "Woodrow",
        value: 6830,
    },
    {
        label: "Wroxton",
        value: 6832,
    },
    {
        label: "Wynyard",
        value: 6834,
    },
    {
        label: "Yarbo",
        value: 6840,
    },
    {
        label: "Yellow Creek",
        value: 6842,
    },
    {
        label: "Yellow Grass",
        value: 6844,
    },
    {
        label: "Yorkton",
        value: 6846,
    },
    {
        label: "Young",
        value: 6848,
    },
    {
        label: "Zealandia",
        value: 6852,
    },
    {
        label: "Zehner",
        value: 6853,
    },
    {
        label: "Zelma",
        value: 6854,
    },
    {
        label: "Zeneta",
        value: 6855,
    },
    {
        label: "Zenon Park",
        value: 6856,
    },
    {
        label: "Zumbro",
        value: 6864,
    },
];
